<template>
  <v-container>
    <div v-if="visibleData.length > 0">
      <v-row wrap>
        <v-col v-for="(data, index) in visibleData" :key="index" v-if='data.visible' class="col-12" sm="6" md="6" style="padding: 7px 5px">
          <v-card class="main_card" elevation="3">
            <v-card-title style="padding: 4px 20px">
              <v-row wrap>
                <v-col v-if="showCheckBox(data)" class="col-1" sm="1" md="1" style="text-align: center; margin-top: 3px; padding: 0px">
                  <div style="text-align: center">
                    <v-checkbox :value="data.id" v-model="selectedIds" @change="selectDataIds"></v-checkbox>
                  </div>
                </v-col>
                <v-col v-else class="col-1" sm="1" md="1" style="text-align: center; margin-top: 3px; padding: 0px">
                  
                </v-col>
                <v-col class="col-7" sm="8" md="8" style="text-align: left; margin-top: 7px; padding: 0px">
                  <h4 class="weekoff_h4">{{data.title}}</h4>
                </v-col>
                <v-col class="col-4" sm="3" md="3" style="text-align: center; margin-top: 16px; padding: 0px">
                  <v-row wrap >
                    <v-col v-if="$store.state.userDetails.role.toLowerCase() == 'superadmin'" class="col-6" sm="6" md="6" style="text-align: center; padding: 0px">
                      <v-btn
                        @click="del(data)"
                        icon
                      >
                        <v-icon color="error" >delete</v-icon>
                      </v-btn>
                    </v-col>
                    <v-col v-else class="col-6" sm="6" md="6" style="text-align: center; padding: 0px">
                    </v-col>

                    <v-col class="col-6" sm="6" md="6" style="text-align: center; padding: 0px">
                      <v-btn
                        @click="edit(data)"
                        icon
                      >
                        <v-icon 
                        color="primary">edit</v-icon>
                      </v-btn>
                    </v-col>

                  </v-row>
                </v-col>
              </v-row>
            </v-card-title>

            <v-divider style="margin: 5px 20px; background: #338AFF; border: 1px solid #338AFF;" ></v-divider>

            <v-card-text style="padding: 0px 20px">
              <v-row wrap style="padding: 5px 15px">
                <v-col class="col-12" sm="12" md="12" style="padding: 3px">
                  <v-row v-for="(content,i) in data.contents"  :key="i" wrap>
                    <v-col class="col-4" sm="4" md="4" style="padding: 2px; white-space: nowrap; overflow: hidden;text-overflow: ellipsis;">
                      <h6 class="weekoff_h6">{{ i }} :</h6>
                    </v-col>
                    <v-col class="col-8" sm="8" md="8" style="padding: 2px;white-space: nowrap; overflow: hidden;text-overflow: ellipsis;">
                      <h5 class="weekoff_h5" >{{ content }}</h5>
                    </v-col>
                  </v-row>
                </v-col>
              </v-row>
            </v-card-text>

          </v-card>
        </v-col>

      </v-row>

      <!-- pagination -->
      <v-row>
        <v-col v-if="$store.getters.userDetails.role.toLowerCase() != 'user'" class="col-12" sm="8" md="8">
          <v-row wrap>
            <v-col class="col-8" sm="4" md="4">
              <v-select
                v-model="records"
                :items="rowsPerPage"
                @input="getPageDetails"
                label="Records per page"
                style="margin-top: -2px; font-size: 14px"
                dense
                outlined
              ></v-select>
            </v-col>

            <v-col class="col-2" sm="2" md="2">
              <v-btn :disabled="currentPage != 0 ? false : true" @click="prev" fab text small  color="primary"> <v-icon>navigate_before</v-icon></v-btn>
            </v-col>

            <v-col class="col-2" sm="2" md="2">
                <v-btn :disabled="currentPage == totalPages-1 ? true : false" @click="next" fab small color="primary" text> <v-icon>navigate_next</v-icon> </v-btn>
            </v-col>

          </v-row>
        </v-col>
      </v-row>
    </div>

    <div v-else style="text-align: center; margin-top: 10px">
      <v-card style="padding: 10px" flat>
        <v-card-text>
            <v-img
              :src="noSearchResultImage"
              class="mb-3"
              contain
              height="300"
            ></v-img>
            <h4 style="font-size: 17px; opacity: 0.7; font-weight: 500">
              Sorry, no records found
            </h4>
        </v-card-text>
      </v-card>
    </div>


  </v-container>
</template>

<script>
import canSee from '@/utilities/canSee';

export default {
    name: 'Card',
    props: {
      renderData: {
        type: Array
      },
      selectAll: {
        type: Boolean
      },
    },
    data() {
      return  {
        selectedIds: [],
        direction: 'bottom',
        tabs: null,
        top: false,
        right: true,
        left: false,
        transition: 'slide-x-reverse-transition',
        visibleData: [],
        rowsPerPage: [ '4', '8', '16', 'All'],
        
        currentPage: 0,
        totalPages: '',
      }
    },
    computed : {
      noSearchResultImage() {
        return require('@/assets/noSearchResult.png')
      },
      records : {
        get: function() {
          
           if(this.$store.getters.pagination[this.$router.currentRoute.name]){
             return this.$store.getters.pagination[this.$router.currentRoute.name]
           }else {
             return this.$store.getters.pagination["default"]
           }
              
                            
          
        },
        set: function(val) {
          this.$store.commit("setPagination", {
            name: this.$router.currentRoute.name,
            pagination: val
          });
          
          this.getPageDetails()
        }
      }
    },
    watch : {
      records(){
        this.getPageDetails()
      }
    },
    async created() {
      await this.getPageDetails()

      if(this.selectAll){
        this.selectedIds = []

        _.each(this.renderData, (d) => {
          if (d.role) {
            
            var dummyArray = _.filter(this.renderData, (user) => { return user.role.toLowerCase() == "superadmin" })

            if(this.$store.getters.userDetails.role.toLowerCase() == "admin" || this.$store.getters.userDetails.role.toLowerCase() == "superadmin" ){
              
                _.each( dummyArray, (obj) => {
                    if(d.id != obj.id){
                      this.selectedIds.push(d.id)
                    }
                })

            }
          } else {
            
            this.selectedIds.push(d.id)
          }
        })

        this.$emit('selectDataIds', this.selectedIds)
      }

    },
    methods: {

      showCheckBox(data){
        if(data.role){
          if(this.$store.getters.userDetails.role.toLowerCase() == "admin" && data.role.toLowerCase() == "superadmin"){
            return false
          }else if(this.$store.state.userDetails.role.toLowerCase() == "user") {
            return false
          }else {
            return true
          }
        } else {
          if(this.$store.getters.userDetails.role.toLowerCase() == "admin" || this.$store.state.userDetails.role.toLowerCase() == "user") {
            return false
          } else {
              return true
          }

        }


      },

      async getPageDetails(){

        var records = Number(this.records)
        var filterData = _.filter(this.renderData, (data) => {return data.visible == true})
        this.renderData = filterData
        this.totalPages = Math.ceil( this.renderData.length / records )

        if( this.records.toString() == "All"){
          this.visibleData = this.renderData
        } else {
          this.visibleData = this.renderData.slice((this.currentPage * records), ((this.currentPage * records) + records))
        }

        if(this.visibleData.length == 0 && this.currentPage > 0){
          this.updateRecords(this.currentPage - 1)
        }

        this.selectedIds = []
      },

      updateRecords( page ) {
        this.currentPage = page
        this.getPageDetails()
      },

      next(){
        this.currentPage ++
        this.getPageDetails()
      },

      prev(){
        this.currentPage --
        this.getPageDetails()
      },

      selectDataIds(){
        this.$emit('selectDataIds', this.selectedIds)
      },
      canSee(what, role) {
        return canSee(this, what, role);
      },
      del(item){
        this.$emit("deleteData", item)
      },
      edit(item){
        this.$emit("editData", item)
      },

    }
};
</script>

<style scoped>
.main_card {
  border-radius: 3px !important;
  background-color: #fff !important;
  outline: none;
  padding: 10px
}
.weekoff_h4{
  margin-top: 13px;
  font-size: 16px;
  font-weight: 550;
}
.weekoff_h5{
  font-size: 13px;
  margin-bottom: 5px;
  padding: 5px 0px;
  text-align: right;
  margin-top: -2px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  color: #1d1d1d;
}
.weekoff_h6 {
  font-size: 13px;
  color: #1a1a1a;
  margin-bottom: 5px;
  font-weight: 600;
  text-align: left;
  padding: 4px 0px
}
.close {
  right: -60px;
  top: -37px;
}
</style>
